const setMomentDateObjZero = momentDate => {
    momentDate.hour(0)
    momentDate.minute(0)
    momentDate.second(0)
    momentDate.milliseconds(0)

    return momentDate
}


export default setMomentDateObjZero